import { useState } from 'react';
import { Link } from 'react-router-dom';
import { newsArticles } from '@/mocks/news';

export default function NewsSection() {
  const [hovered, setHovered] = useState<number | null>(null);
  const featured = newsArticles.slice(0, 3);
  const secondary = newsArticles.slice(3, 6);

  return (
    <section className="w-full bg-white py-20 px-6 md:px-12">
      {/* Section Header */}
      <div className="max-w-7xl mx-auto mb-12">
        <div className="flex items-center gap-4 mb-3">
          <span className="inline-block w-10 h-0.5 bg-[#4a1a6b]"></span>
          <span
            className="text-[#4a1a6b] text-xs font-bold tracking-[0.4em] uppercase"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            Latest Updates
          </span>
          <span className="inline-block w-10 h-0.5 bg-[#4a1a6b]"></span>
        </div>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <h2
            className="text-4xl md:text-5xl font-black uppercase text-gray-900"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            PurplePride &amp; <span className="text-[#4a1a6b]">Vikings News</span>
          </h2>
          <Link
            to="/news"
            className="whitespace-nowrap text-sm font-bold tracking-widest uppercase text-[#4a1a6b] border-b-2 border-[#ffd700] pb-0.5 hover:text-[#ffd700] transition-colors cursor-pointer"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            View All News &rarr;
          </Link>
        </div>
      </div>

      {/* Featured 3 Cards */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {featured.map((article) => (
          <article
            key={article.id}
            className="group rounded-2xl overflow-hidden bg-white border border-gray-100 cursor-pointer transition-transform duration-300 hover:-translate-y-1"
            onMouseEnter={() => setHovered(article.id)}
            onMouseLeave={() => setHovered(null)}
          >
            <div className="relative w-full h-52 overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span
                className="absolute top-3 left-3 bg-[#ffd700] text-[#4a1a6b] text-xs font-bold px-3 py-1 rounded-full tracking-wider uppercase"
                style={{ fontFamily: "'Oswald', sans-serif" }}
              >
                {article.category}
              </span>
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-2">
                <i className="ri-calendar-line text-gray-400 text-xs"></i>
                <span className="text-gray-400 text-xs" style={{ fontFamily: "'Oswald', sans-serif" }}>{article.date}</span>
                <span className="text-gray-300 text-xs">·</span>
                <span className="text-gray-400 text-xs" style={{ fontFamily: "'Oswald', sans-serif" }}>{article.author}</span>
              </div>
              <h3
                className={`text-base font-bold leading-snug transition-colors duration-200 ${hovered === article.id ? 'text-[#4a1a6b]' : 'text-gray-900'}`}
                style={{ fontFamily: "'Oswald', sans-serif" }}
              >
                {article.title}
              </h3>
              <p className="text-gray-500 text-sm mt-2 leading-relaxed line-clamp-2">{article.excerpt}</p>
            </div>
          </article>
        ))}
      </div>

      {/* Secondary 3 Cards - horizontal list */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
        {secondary.map((article) => (
          <article
            key={article.id}
            className="group flex gap-4 items-start cursor-pointer p-4 rounded-xl hover:bg-gray-50 transition-colors duration-200"
          >
            <div className="w-20 h-20 flex-shrink-0 rounded-lg overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
              />
            </div>
            <div className="flex-1 min-w-0">
              <span
                className="text-[#4a1a6b] text-xs font-bold tracking-wider uppercase"
                style={{ fontFamily: "'Oswald', sans-serif" }}
              >
                {article.category}
              </span>
              <h4
                className="text-sm font-bold text-gray-900 mt-1 leading-snug group-hover:text-[#4a1a6b] transition-colors"
                style={{ fontFamily: "'Oswald', sans-serif" }}
              >
                {article.title}
              </h4>
              <p className="text-gray-400 text-xs mt-1">{article.date}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
